// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"04502313","321":"8396b436","326":"180ef9e2","428":"66efd384","701":"d674418a","925":"c17f6bd3"}[chunkId] + ".chunk.css";
};